import { StreamingProvider } from "src/lib/movieinfo/movieinfotypes";

export const STREAMING_GENRES = ["Action",
	"Animasjon",
	"Dokumentar",
	"Drama",
	"Eventyr",
	"Familie",
	"Fantasy",
	"Komedie",
	"Krim",
	"Musikk",
	"Realityserier",
	"Romantikk",
	"Science fiction",
	"Skrekk",
	"Thriller",
	"Western"
];

export interface IFindSomethingToStreamFilterState {
	showOptionsFilmOrSeries: boolean;
	showOptionsGenre: boolean;
	showOptionsPeriod: boolean;
	showOptionsProviders: boolean;
	moviesOnly: boolean;
	seriesOnly: boolean;
	genres: string[];
	providers: StreamingProvider[];
	yearFrom: number;
	yearTo: number;
	activeSearch: boolean;
}

export const INTIAL_STATE: IFindSomethingToStreamFilterState = {
	showOptionsFilmOrSeries: false,
	showOptionsGenre: false,
	showOptionsPeriod: false,
	showOptionsProviders: false,
	moviesOnly: false,
	seriesOnly: false,
	genres: [],
	providers: [],
	yearFrom: 0,
	yearTo: 0,
	activeSearch: false
};

type HideOptionsAction = {
	type: "hideOptions";
};

type ShowOptionsFilmOrSeriesAction = {
	type: "showOptionsFilmOrSeries";
};

type ShowOptionsGenreAction = {
	type: "showOptionsGenre";
};

type ShowOptionsPeriodAction = {
	type: "showOptionsPeriod";
};

type ShowOptionsProviderAction = {
	type: "showOptionsProviders";
};

type SetFilmOrSeriesShowAllAction = {
	type: "setFilmOrSeriesShowAll";
};

type SetGenresAction = {
	type: "setGenres";
	genres: string[];
};

type SetMoviesOnlyAction = {
	type: "setMoviesOnly";
};

type SetPeriodAction = {
	type: "setPeriod";
	yearFrom: number;
	yearTo: number;
};

type SetProvidersAction = {
	type: "setProviders";
	providers: StreamingProvider[];
};

type SetSeriesOnlyAction = {
	type: "setSeriesOnly";
};

type PreInitializeFilterAction = {
	type: "preinitfilter";
	genres: string[];
	providers: StreamingProvider[];
	yearFrom: number;
	yearTo: number;
	seriesOnly: boolean;
	moviesOnly: boolean;
};

export type FilterAction = HideOptionsAction
	| ShowOptionsFilmOrSeriesAction
	| ShowOptionsGenreAction
	| ShowOptionsPeriodAction
	| ShowOptionsProviderAction
	| SetFilmOrSeriesShowAllAction
	| SetGenresAction
	| SetMoviesOnlyAction
	| SetPeriodAction
	| SetProvidersAction
	| SetSeriesOnlyAction
	| PreInitializeFilterAction;

export function filterReducer(state: IFindSomethingToStreamFilterState, action: FilterAction): IFindSomethingToStreamFilterState {

	let newState = state;

	switch (action.type) {
		case "hideOptions":
			newState = { ...state, showOptionsGenre: false, showOptionsFilmOrSeries: false, showOptionsPeriod: false, showOptionsProviders: false };
			break;
		case "showOptionsFilmOrSeries":
			newState = { ...state, showOptionsFilmOrSeries: true };
			break;
		case "showOptionsGenre":
			newState = { ...state, showOptionsGenre: true };
			break;
		case "showOptionsPeriod":
			newState = { ...state, showOptionsPeriod: true };
			break;
		case "showOptionsProviders":
			newState = { ...state, showOptionsProviders: true };
			break;
		case "setFilmOrSeriesShowAll":
			newState = { ...state, moviesOnly: false, seriesOnly: false, showOptionsFilmOrSeries: false };
			break;
		case "setGenres":
			newState = { ...state, genres: action.genres, showOptionsGenre: false };
			break;
		case "setMoviesOnly":
			newState = { ...state, moviesOnly: true, seriesOnly: false, showOptionsFilmOrSeries: false };
			break;
		case "setPeriod":
			newState = { ...state, yearFrom: action.yearFrom, yearTo: action.yearTo, showOptionsPeriod: false };
			break;
		case "setProviders":
			newState = { ...state, providers: action.providers, showOptionsProviders: false };
			break;
		case "setSeriesOnly":
			newState = { ...state, seriesOnly: true, moviesOnly: false, showOptionsFilmOrSeries: false };
			break;
		case "preinitfilter":
			newState = {
				...state,
				genres: action.genres,
				providers: action.providers,
				yearFrom: action.yearFrom,
				yearTo: action.yearTo,
				moviesOnly: action.moviesOnly,
				seriesOnly: action.seriesOnly
			};
			break;
	}

	newState.activeSearch = newState.genres.length > 0
		|| newState.moviesOnly
		|| newState.seriesOnly
		|| newState.providers.length > 0
		|| newState.yearFrom !== 0
		|| newState.yearTo !== 0;

	return newState;
}